/** Food Safety °C ranges: "1–5°C", but "−25 to −18°C" when a bound is negative. */

const MINUS = '\u2212'

/** Pure: true minus sign for negatives ("−18"), else as given. */
export function formatTempValue(value) {
  const n = Number(value)
  if (value == null || value === '' || !Number.isFinite(n))
    return String(value ?? '')
  return n < 0 ? `${MINUS}${Math.abs(n)}` : String(n)
}

/** Pure: "1–5°C"; "−25 to −18°C" / "−2 to 4°C" once either bound is negative. */
export function formatTempRange(min, max) {
  const negative = Number(min) < 0 || Number(max) < 0
  const joiner = negative ? ' to ' : '–'
  return `${formatTempValue(min)}${joiner}${formatTempValue(max)}°C`
}

/** Same wording as formatTempRange, but '' when either bound is missing. */
export function formatFoodSafetyTempRange(min, max) {
  const lo = Number(min)
  const hi = Number(max)
  if (!Number.isFinite(lo) || !Number.isFinite(hi)) return ''
  return formatTempRange(lo, hi)
}
